import { render, staticRenderFns } from "./ArchiveItemIcon.vue?vue&type=template&id=df654308&scoped=true"
import script from "./ArchiveItemIcon.vue?vue&type=script&lang=js"
export * from "./ArchiveItemIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df654308",
  null
  
)

export default component.exports